/**
 * <h4>Generating recommended products</h4>
 *
 * @packageDocumentation
 */

export {Product} from './IO/Output/Product'
export {ProductCustomAttribute} from './IO/Output/ProductCustomAttribute'

export {RecommendationParams} from './IO/Input/RecommendationParams'
export {RecommendationError} from './IO/Output/Error/RecommendationError'
export {RecommendationInterface} from './Recommendation'
export {RecommendationImpl as Recommendation} from './RecommendationImpl'
export {FilterApi} from './FilterApi'

/** @module */
export * as Filters from './IO/Input/Filters/'

/** @module */
export * as Error from './IO/Output/Error/'


// @todo:
// możliwe do przekazania do zgłoszenia o ramkę reko:
// case 'user':                    $qparams['u'] = $value; break;
// case 'user_type':               $qparams['ut'] = $value; break;
// case 'emailIdentity':           $qparams['emailIdentity'] = $value; break;
